(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__countdownLoopInit) return;
    window.__countdownLoopInit = true;

    var timers = new WeakMap();

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tickTimer(entry) {
      entry.remaining--;
      if (entry.remaining < 0) entry.remaining = entry.duration;

      var t = entry.remaining;
      var d = Math.floor(t / 86400);
      var h = Math.floor((t % 86400) / 3600);
      var m = Math.floor((t % 3600) / 60);
      var s = t % 60;

      if (entry.daysEl) entry.daysEl.textContent = pad(d);
      if (entry.hoursEl) entry.hoursEl.textContent = pad(h);
      if (entry.minutesEl) entry.minutesEl.textContent = pad(m);
      if (entry.secondsEl) entry.secondsEl.textContent = pad(s);
    }

    function initElement(el) {
      if (timers.has(el)) return;

      var duration = parseInt(el.getAttribute('data-countdown-loop'), 10) || 600;
      var entry = {
        remaining: duration,
        duration: duration,
        daysEl: el.querySelector('[data-unit="days"]'),
        hoursEl: el.querySelector('[data-unit="hours"]'),
        minutesEl: el.querySelector('[data-unit="minutes"]'),
        secondsEl: el.querySelector('[data-unit="seconds"]')
      };

      /* Affichage initial */
      tickTimer(entry);
      entry.remaining++;

      var intervalId = setInterval(function() {
        /* Si l element a ete retire du DOM, on arrete */
        if (!document.body.contains(el)) {
          clearInterval(intervalId);
          timers.delete(el);
          return;
        }
        tickTimer(entry);
      }, 1000);

      timers.set(el, intervalId);
    }

    function scanAndInit() {
      var elements = document.querySelectorAll('[data-countdown-loop]');
      for (var i = 0; i < elements.length; i++) {
        initElement(elements[i]);
      }
    }

    /* Scan initial */
    scanAndInit();

    /* MutationObserver pour detecter les nouveaux elements (drawer AJAX) */
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        scanAndInit();
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    /* Fallback : scan toutes les 500ms au cas ou */
    setInterval(scanAndInit, 500);
  })();
  } catch(e) { console.error(e); }
})();

})();
